import type { ReactElement } from 'react';
import {
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import type {
  MarkdownRemarkFrontmatterCopy,
  MarkdownRemarkFrontmatterGlobalPayoutData,
} from '../../../generated/types';

export type PpGlobalPayoutTable = {
  copy: MarkdownRemarkFrontmatterCopy;
  countryData: MarkdownRemarkFrontmatterGlobalPayoutData | undefined;
};

const StyledTable = styled(Table)(({ theme }) => ({
  color: theme.palette.websiteBrand.greyscale.grey,
  maxWidth: theme.breakpoints.values.sm,
  '& .MuiTableBody-root .MuiTableCell-root': {
    ...theme.typography.paragraphBodyS,
  },
  '& .MuiTableBody-root .MuiTableCell-root, & .MuiTableHead-root .MuiTableCell-root': {
    borderBottom: `1px solid ${theme.palette.websiteBrand.greyscale.grey}`,
    padding: theme.spacing(1),
  },
  '& .MuiTableBody-root tr:last-child .MuiTableCell-root': {
    borderBottom: 'none',
  },
  '& .MuiTableHead-root .MuiTableCell-root': {
    ...theme.typography.paragraphBodySBold,
  },
}));

export function GlobalPayoutTable({ copy, countryData }: PpGlobalPayoutTable): ReactElement {
  if (!countryData) {
    return (
      <Stack>
        <Typography variant="paragraphBodyS">{copy?.notAvailable}</Typography>
      </Stack>
    );
  }
  return (
    <Stack>
      <TableContainer>
        <StyledTable size="small">
          <TableHead>
            <TableRow>
              <TableCell>{copy?.tableHead1}</TableCell>
              <TableCell>{copy?.tableHead2}</TableCell>
              <TableCell>{copy?.tableHead3}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {countryData.payoutChannels?.map((item) => (
              <TableRow key={item?.id}>
                <TableCell>{item?.method}</TableCell>
                <TableCell>{item?.processingTime}</TableCell>
                <TableCell>{item?.currency}</TableCell>
              </TableRow>
            ))}
            {countryData.cardAcceptance?.map((item) => (
              <TableRow key={item?.id}>
                <TableCell>{item?.method}</TableCell>
                <TableCell>{item?.processingTime}</TableCell>
                <TableCell>{item?.currency}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </StyledTable>
      </TableContainer>
    </Stack>
  );
}
